/** Intro copy for /docusign-vs-prime-document-sign (landing + blog). */
export function DocuSignVsPrimeIntroBlocks({ t, variant = 'landing' }) {
  const isBlog = variant === 'blog'
  const prose = isBlog ? undefined : 'docusign-alt-landing__prose'
  const hook = isBlog ? 'blog-article-body__intro-hook' : 'docusign-alt-landing__prose docusign-alt-landing__intro-hook'
  return (
    <>
      <p className={hook}>{t('seoLanding.docuVs.intro1')}</p>
      <p className={prose}>{t('seoLanding.docuVs.intro2')}</p>
      <p className={prose}>{t('seoLanding.docuVs.intro3')}</p>
      <p className={prose}>{t('seoLanding.docuVs.intro4')}</p>
    </>
  )
}
